import { motion } from 'framer-motion';
import { ImageWithFallback } from './ImageWithFallback';

type Props = {
  src: string;
  alt: string;
  className?: string;
  delay?: number;
};

export function Sticker({ src, alt, className = '', delay = 0 }: Props) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, scale: 0.7, rotate: -8 }}
      whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
      viewport={{ once: true }}
      animate={{ y: [0, -7, 0], rotate: [0, 2, -2, 0] }}
      transition={{
        opacity: { delay },
        scale: { delay },
        y: { duration: 3.8, repeat: Infinity, ease: 'easeInOut', delay },
        rotate: { duration: 5.2, repeat: Infinity, ease: 'easeInOut', delay },
      }}
    >
      <ImageWithFallback src={src} alt={alt} className="h-full w-full object-contain" />
    </motion.div>
  );
}
